module.exports = "/_next/static/images/game-1-phone-attachment-cat-a4c1ddecaca21ce74cda5fc413093885.gif";